// DO NOT EDIT -- generated from fs/services/llm-tool/schema_test.proto

import * as protobuf from '../../../google/protobuf';

export interface TestMessage {
  stringField: string;
  intField: number;
  boolArray: boolean[];
  nested: NestedMessage | null;
  nestedArray: NestedMessage[];
  bytesField: protobuf.bytes;
  fixedField: protobuf.uint64;
  floatField: number;
  enumField: TestEnum;
}

export interface NestedMessage {
  numberField: number;
  nestedString: string;
}

export enum TestEnum {
  UNKNOWN = 0,
  FIRST = 1,
  SECOND = 2
}
